<template>
    <div class="data-div">
        <ul class="data-show">
            <li
                v-for="(item, index) in statsData"
                :key="item.key"
                class="stat-item"
                :style="{ animationDelay: `${index * 0.1}s` }"
            >
                <div class="icon-wrapper">
                    <img :src="item.icon" :alt="item.label">
                </div>
                <div class="data-content">
                    <div class="number-row">
                        <span
                            v-for="(char, charIndex) in getFormattedNumber(item.key)"
                            :key="charIndex"
                            class="num digit"
                            :class="{ 'comma': char === ',' }"
                        >
                            {{ char }}
                        </span>
                        <span class="num plus">+</span>
                    </div>
                    <div class="label">{{ item.label }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'NewestNotic',
    data() {
        return {
            // 统一数据配置
            statsConfig: [
                { key: 'users', icon: require('@/assets/icon/data/user.svg'), label: '用户总数', target: 1780004 },
                { key: 'questions', icon: require('@/assets/icon/data/panduan.svg'), label: '题目数量', target: 2605004 },
                { key: 'exams', icon: require('@/assets/icon/data/kaoshi.svg'), label: '累计考试人次', target: 7010004 },
                { key: 'judgments', icon: require('@/assets/icon/data/pin.svg'), label: '累计评判次数', target: 6220004 }
            ],
            // 动态数值存储
            actualNumbers: {
                users: 0,
                questions: 0,
                exams: 0,
                judgments: 0
            },
            // 动画控制
            animationFrameIds: {}
        };
    },
    computed: {
        // 合并配置和实际数值
        statsData() {
            return this.statsConfig.map(item => ({
                ...item,
                current: this.actualNumbers[item.key]
            }));
        }
    },
    mounted() {
        this.startAllAnimations();
    },
    beforeDestroy() {
        // 清理动画帧，防止内存泄漏
        this.cancelAllAnimations();
    },
    methods: {
        // 获取格式化后的数字
        getFormattedNumber(key) {
            return this.actualNumbers[key].toLocaleString('en-US');
        },

        // 启动所有数字动画
        startAllAnimations() {
            this.statsConfig.forEach((item, index) => {
                // 错开启动时间，产生波浪效果
                setTimeout(() => {
                    this.animateNumber(item.key, item.target);
                }, index * 100);
            });
        },

        // 通用数字动画方法
        animateNumber(key, target) {
            const easeOutQuart = t => 1 - Math.pow(1 - t, 4);
            const duration = 1500; // 动画持续时间(ms)
            const startTime = performance.now();
            const startValue = this.actualNumbers[key];

            const animate = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = easeOutQuart(progress);

                this.actualNumbers[key] = Math.round(startValue + (target - startValue) * easedProgress);

                if (progress < 1) {
                    this.animationFrameIds[key] = requestAnimationFrame(animate);
                } else {
                    this.actualNumbers[key] = target; // 确保最终值精确
                }
            };

            this.animationFrameIds[key] = requestAnimationFrame(animate);
        },

        // 取消所有动画
        cancelAllAnimations() {
            Object.values(this.animationFrameIds).forEach(id => {
                cancelAnimationFrame(id);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.data-div {
    width: 1200px;
    height: 180px;
    margin: 0 auto -60px;
    position: relative;
    cursor: pointer;
}

.data-show {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 40px;
    list-style: none;
    margin: 0;
    padding-left: 0;
}

.stat-item {
    display: flex;
    align-items: flex-start;
    padding: 16px 20px;
    border-radius: 12px;
    transition: all 0.3s ease;
    animation: fadeInUp 0.6s ease-out both;

    &:hover {
        background: rgba(55, 118, 255, 0.04);
        transform: translateY(-4px);

        .icon-wrapper img {
            transform: scale(1.1);
        }

        .num {
            color: #3776ff;
        }
    }
}

.icon-wrapper {
    flex-shrink: 0;

    img {
        width: 59px;
        height: 59px;
        transition: transform 0.3s ease;
    }
}

.data-content {
    margin-left: 20px;
    text-align: left;
}

.number-row {
    display: flex;
    align-items: baseline;
}

.num {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    line-height: 1;
    letter-spacing: -2px;
    transition: color 0.3s ease;

    &.comma {
        letter-spacing: 0;
        margin: 0 1px;
    }

    &.plus {
        letter-spacing: 0;
        margin-left: 2px;
        color: #333;
    }
}

.label {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
    transition: color 0.3s ease;

    .stat-item:hover & {
        color: #333;
    }
}

// 入场动画
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

</style>
